/* =========================================================================
   FLASH PROMO LIPLEGGING 14/10 — CARTÃO "ADICIONE A 2ª" NA GAVETA (08/10/2026)

   Clone do tp-data-dupla.js com um desconto só. Lê o estado publicado pela
   gaveta (snippets/tp-flash-lip-carrinho.liquid, <script data-tp-fl>), que a
   gaveta refaz a cada mudança do carrinho. Com a oferta no ar e peça da
   coleção sem par no carrinho (1, 3, 5...), sobe o cartão no rodapé:
   "Adicione a 2ª LipLegging e ganhe 10% OFF · até R$ X OFF".
   "Adicionar a 2ª" volta para a coleção; "Não, obrigada" cala esse número
   de peças por 30 minutos (localStorage). Com o par fechado, some.

   A OFERTA MANDA: ao abrir, avisa (evento tp-oferta-cartao) e os cartões da
   roleta saem de cena.
   ========================================================================= */
(function () {
  if (window.__tpFlashLip) return;
  window.__tpFlashLip = true;

  var raiz = null, timer = null, visto = null, vistoTxt = null;
  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function avisar(aberto) { try { document.dispatchEvent(new CustomEvent('tp-oferta-cartao', { detail: { aberto: !!aberto, quem: 'flash-liplegging' } })); } catch (e) {} }

  function lerSilencio() {
    var m = {};
    try { var b = JSON.parse(localStorage.getItem('tp-flc-silencio') || '{}'); if (b && typeof b === 'object') m = b; } catch (e) {}
    var agora = Date.now();
    Object.keys(m).forEach(function (k) { if (!(parseInt(m[k], 10) > agora)) delete m[k]; });
    return m;
  }

  function montar() {
    if (raiz) return raiz;
    var css = document.createElement('style');
    css.textContent = '.tp-flc{position:fixed;z-index:2147483000;left:50%;bottom:16px;width:min(100% - 24px,380px);transform:translate(-50%,16px);opacity:0;display:flex;align-items:flex-start;gap:12px;padding:14px 16px 14px 14px;border-radius:16px;background:#222F28;color:#F1F0EB;box-shadow:0 10px 30px rgba(34,47,40,.28);font-family:var(--tp-body-font,"Host Grotesk",ui-sans-serif,system-ui,sans-serif);transition:opacity .22s ease,transform .22s ease}'
      + '.tp-flc[hidden]{display:none}.tp-flc.is-aberto{opacity:1;transform:translate(-50%,0)}'
      + '@media (min-width:750px){.tp-flc{left:auto;right:20px;bottom:20px;transform:translateY(16px)}.tp-flc.is-aberto{transform:translateY(0)}}'
      + '.tp-flc__icone{flex:0 0 auto;width:38px;height:38px;border-radius:12px;background:rgba(255,170,153,.18);color:#FFAA99;display:inline-flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;letter-spacing:-.02em}'
      + '.tp-flc__corpo{flex:1 1 auto;min-width:0}.tp-flc__eyebrow{margin:0 0 2px;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#FFAA99;font-weight:600}'
      + '.tp-flc__titulo{margin:0 0 4px;font-size:1.45rem;line-height:1.3;font-weight:600}.tp-flc__titulo b{color:#FFAA99;font-weight:700}'
      + '.tp-flc__texto{margin:0 0 10px;font-size:1.2rem;line-height:1.4;color:rgba(241,240,235,.78)}.tp-flc__texto b{color:#F1F0EB;font-weight:700}'
      + '.tp-flc__acoes{display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
      + '.tp-flc__sim{display:inline-flex;align-items:center;padding:9px 14px;border-radius:999px;background:#FFAA99;color:#222F28;font-size:1.25rem;font-weight:700;text-decoration:none}'
      + '.tp-flc__nao{border:0;background:transparent;padding:6px 2px;color:rgba(241,240,235,.75);font:inherit;font-size:1.2rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-flc';
    el.setAttribute('role', 'status');
    el.hidden = true;
    el.innerHTML = '<span class="tp-flc__icone" aria-hidden="true">2ª</span>'
      + '<div class="tp-flc__corpo"><p class="tp-flc__eyebrow">Flash Promo · só hoje</p><p class="tp-flc__titulo" data-flc-titulo></p><p class="tp-flc__texto" data-flc-texto></p>'
      + '<div class="tp-flc__acoes"><a class="tp-flc__sim" data-flc-sim href="#">Adicionar a 2ª</a><button type="button" class="tp-flc__nao" data-flc-nao>Não, obrigada</button></div></div>';
    document.body.appendChild(el);
    function silenciar() {
      if (!raiz || !raiz.__passo) return;
      try { var m = lerSilencio(); m[raiz.__passo] = Date.now() + 30 * 60 * 1000; localStorage.setItem('tp-flc-silencio', JSON.stringify(m)); } catch (e) {}
    }
    el.querySelector('[data-flc-nao]').addEventListener('click', function () { silenciar(); fechar(); });
    el.querySelector('[data-flc-sim]').addEventListener('click', function () { silenciar(); fechar(); });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { setTimeout(posicionar, 350); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', posicionar);
    raiz = el;
    return el;
  }
  function posicionar() {
    if (!raiz) return;
    if (window.innerWidth < 750) { raiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    raiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function fechar() {
    if (!raiz || raiz.hidden) return;
    var estavaAberto = raiz.classList.contains('is-aberto');
    raiz.classList.remove('is-aberto');
    var el = raiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
    if (estavaAberto) avisar(false);
  }
  function bloqueado() {
    var h = document.documentElement.classList;
    return h.contains('tp-roleta-open') || h.contains('tp-pg-open') || h.contains('tp-pt-open') || h.contains('tp-pe-open');
  }

  function decidir() {
    var el = document.querySelector('[data-tp-fl]');
    if (!el) { fechar(); return; }
    var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }
    if (!d.ativa || !d.qtd || d.qtd % 2 === 0) { fechar(); return; }
    if (d.fim && Date.now() / 1000 > d.fim) { fechar(); return; }
    var passo = 'flash-liplegging:' + d.qtd;
    if (lerSilencio()[passo]) { fechar(); return; }
    if (bloqueado()) return;
    var box = montar();
    box.__passo = passo;
    box.querySelector('[data-flc-titulo]').innerHTML = 'Adicione a <b>2ª ' + (d.nome || 'peça') + '</b> e ganhe <b>' + d.seg + '% OFF</b>';
    box.querySelector('[data-flc-texto]').innerHTML = (d.economiaMax > 0 ? 'Até <b>' + brl(d.economiaMax) + ' OFF</b> na segunda. ' : '') + 'O desconto entra sozinho no carrinho.';
    var sim = box.querySelector('[data-flc-sim]');
    if (d.url) { sim.href = d.url; sim.hidden = false; } else sim.hidden = true;
    var jaAberto = box.classList.contains('is-aberto');
    if (box.hidden) { box.hidden = false; void box.offsetWidth; }
    box.classList.add('is-aberto');
    posicionar();
    if (!jaAberto) avisar(true);
  }

  function mudou() {
    var el = document.querySelector('[data-tp-fl]');
    if (!el) return visto !== null ? ((visto = null), true) : false;
    var txt = el.textContent;
    if (el === visto && txt === vistoTxt) return false;
    visto = el; vistoTxt = txt;
    return true;
  }
  function agendar() { clearTimeout(timer); timer = setTimeout(decidir, 120); }
  function iniciar() {
    mudou();
    decidir();
    var gaveta = document.getElementById('CartDrawer');
    if (gaveta && window.MutationObserver) new MutationObserver(function () { if (mudou()) agendar(); }).observe(gaveta, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { subscribe(PUB_SUB_EVENTS.cartUpdate, agendar); } catch (e) {} }
    if (window.MutationObserver) {
      var estava = bloqueado();
      new MutationObserver(function () { var agora = bloqueado(); if (agora && !estava) fechar(); if (estava && !agora) setTimeout(decidir, 500); estava = agora; }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
